import { render } from "./LeadStatus.vue?vue&type=template&id=690df386"
import script from "./LeadStatus.vue?vue&type=script&lang=js"
export * from "./LeadStatus.vue?vue&type=script&lang=js"
script.render = render

export default script